import React from "react";
import ProjectThumbnail from "../../components/ProjectThumbnail.jsx";

import FeaturedProjThumbnail from "../FeaturedProjThumbnail.jsx";
import TertiaryProjThumbnail from "../TertiaryProjThumbnail.jsx";

const DevList = ({ projectsList }) => {
  return (
    <div>
      <h2> Featured Work</h2>
      <div className="featured-grid">
        {projectsList
          .filter((product) => product.tier === "0")
          .map((item) => (
            <FeaturedProjThumbnail item={item} key={item.id} />
          ))}

        <div className="featured-grid-right">
          {projectsList
            .filter((product) => product.tier === "1")
            .map((item) => (
              <FeaturedProjThumbnail item={item} key={item.id} st="small" />
            ))}
        </div>
      </div>

      <div className="secondary-section">
        <div className="secondary-grid">
          {/* .filter((product) => product.type === "react") */}
          {projectsList
            .filter((product) => product.tier === "2")
            .map((item) => (
              <ProjectThumbnail item={item} key={item.id} />
            ))}
        </div>
      </div>

      <h2>Technical Exercises & Explorations</h2>

      <div className="tertiary-section">
        <div className="tertiary-grid">
          {/* .filter((product) => product.type === "react") */}
          {projectsList
            .filter((product) => product.tier === "3")
            .map((item) => (
              <TertiaryProjThumbnail item={item} key={item.id} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default DevList;
